module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab158-b4489d56ed2b67140b5f8ec0b4efff72.jpg";